import { jsx as _jsx } from "preact/jsx-runtime";
import homeCollectionLoader from './collection.loader';
import CollectionPage from './collection.page';
import HomeRecyclingContactPage from './contact.page';
import HomeRecyclingErrorPage from './error.page';
import HomeRecyclingLayout from './home.layout';
import homeRecyclingLoader from './home.loader';
import HomeRecyclingPage from './home.page';
import homeRecyclingCentreLoader from './recycling-centre.loader';
import HomeRecyclingCentrePage from './recycling-centre.page';
const routes = [
    {
        path: '/:postcode/home',
        loader: homeRecyclingLoader,
        id: 'home-recycling',
        errorElement: _jsx(HomeRecyclingErrorPage, {}),
        children: [
            {
                element: _jsx(HomeRecyclingLayout, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(HomeRecyclingPage, {}),
                    },
                    {
                        path: 'recycling-centre',
                        element: _jsx(HomeRecyclingCentrePage, {}),
                        loader: homeRecyclingCentreLoader,
                    },
                    {
                        path: 'contact',
                        element: _jsx(HomeRecyclingContactPage, {}),
                    },
                ],
            },
            {
                path: 'collection',
                loader: homeCollectionLoader,
                element: _jsx(CollectionPage, {}),
            },
        ],
    },
];
export default routes;
